import { render, staticRenderFns } from "./TinyPost.vue?vue&type=template&id=b88ec426&"
import script from "./TinyPost.vue?vue&type=script&lang=js&"
export * from "./TinyPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports